module.exports = __webpack_public_path__ + "assets/img/logo-frame.bcfcd13b.png";